import { render, staticRenderFns } from "./video.vue?vue&type=template&id=2b770551&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=2b770551&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b770551",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b770551')) {
      api.createRecord('2b770551', component.options)
    } else {
      api.reload('2b770551', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=2b770551&scoped=true&", function () {
      api.rerender('2b770551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video.vue"
export default component.exports